var Tabs = document.querySelectorAll("[data-child-id]");
var ProductTabContents = document.querySelectorAll("[data-tab-content]");

document.querySelectorAll(".custom-text p").forEach((p) => {
  if (p.innerHTML.trim() === "") {
    p.innerHTML = "&nbsp;"; // Adds a non-breaking space
  }
});

Tabs.forEach((tab) => {
  tab.addEventListener("click", () => {
    var target = document.querySelector(`#${tab.dataset.childId}`);
    console.log(target);
    console.log(tab.dataset.childId);
    ProductTabContents.forEach((tabContent) => {
      tabContent.classList.remove("active");
    });
    Tabs.forEach((tab) => {
      tab.classList.remove("active");
    });
    target.classList.add("active");
    tab.classList.add("active");
  });
});
